import React from 'react';
import { Template as ApiTemplate } from '../../../../../types/api';
import { Template } from '../../Templates/Template/Template';
import { forYouTemplatesGridDataHooks } from './ForYouTemplatesGrid.dataHooks';
import s from './ForYouTemplatesGrid.scss';

interface ForYouTemplatesGridProps {
  templates: ApiTemplate[] | null;
  dataHook?: string;
  categorySlug: string;
  subCategorySlug?: string;
}

export const ForYouTemplatesGrid: React.FC<ForYouTemplatesGridProps> = ({
  dataHook,
  templates,
  categorySlug,
  subCategorySlug,
}) => {
  return (
    <ul className={s.templates} data-hook={dataHook}>
      {(templates || []).map((template, index) => (
        <Template
          key={template.id}
          galleryDocIndex={index}
          template={template}
          dataHook={forYouTemplatesGridDataHooks.template()}
          isLastItemHidden={true}
          categorySlug={categorySlug}
          subCategorySlug={subCategorySlug ?? null}
        />
      ))}
    </ul>
  );
};
